import Typography from "@mui/material/Typography";
import { Link } from "react-router";

import {
  TriggerTargetType,
  type TriggerDispatchRecord,
} from "@/shared/domain/triggers";
import { Goto } from "@/shared/navigation";

/**
 * What a dispatched target produced, linked where a page exists:
 * an invocation, an agent thread, or (plain text) a Slack message timestamp.
 */
export function DispatchResultLink({
  dispatch,
}: {
  dispatch: TriggerDispatchRecord;
}) {
  if (!dispatch.result_ref) {
    return (
      <Typography variant="body2" color="text.secondary">
        —
      </Typography>
    );
  }

  switch (dispatch.target_type) {
    case TriggerTargetType.InvokeAction:
      return (
        <Link to={Goto.createInvocationRoute(dispatch.result_ref)}>
          {dispatch.result_ref}
        </Link>
      );
    case TriggerTargetType.StartAgent:
      return (
        <Link to={Goto.createAgentThreadRoute(dispatch.result_ref)}>
          {dispatch.result_ref}
        </Link>
      );
    default:
      return <Typography variant="body2">{dispatch.result_ref}</Typography>;
  }
}
